import { render } from "./applicantsList.vue?vue&type=template&id=e1c9c3fc&scoped=true"
import script from "./applicantsList.vue?vue&type=script&lang=js"
export * from "./applicantsList.vue?vue&type=script&lang=js"

import "./applicantsList.vue?vue&type=style&index=0&id=e1c9c3fc&scoped=true&lang=css"

import exportComponent from "../../../../../procollege/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e1c9c3fc"]])

export default __exports__